<script setup lang="ts">
const { t } = useI18n();
const colorMode = useColorMode();

// CSS custom properties are unavailable during SSR, so keep equivalent concrete fallbacks.
const color = ref(colorMode.value === 'dark' ? '#0f172a' : '#ffffff');
const syncThemeColor = () => {
  const token = colorMode.value === 'dark' ? '--color-app-theme-dark' : '--color-app-theme-light';
  const resolvedColor = getComputedStyle(document.documentElement).getPropertyValue(token).trim();
  if (resolvedColor) {
    color.value = resolvedColor;
  }
};

onMounted(syncThemeColor);
watch(() => colorMode.value, syncThemeColor, { flush: 'post' });

useHead({
  meta: [
    { charset: 'utf-8' },
    {
      name: 'viewport',
      content: 'width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no',
    },
    { key: 'theme-color', name: 'theme-color', content: color },
  ],
  link: [{ rel: 'icon', href: '/favicon.ico' }],
  htmlAttrs: {
    lang: 'en',
  },
});

useSeoMeta({
  title: () => t('app.meta.title'),
  description: () => t('app.meta.description'),
  ogTitle: () => t('app.meta.title'),
  ogDescription: () => t('app.meta.description'),
  // ogImage: 'https://dashboard-template.nuxt.dev/social-card.png',
  // twitterImage: 'https://dashboard-template.nuxt.dev/social-card.png',
  // twitterCard: 'summary_large_image',
});
</script>

<template>
  <UApp>
    <NuxtLoadingIndicator />

    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>
  </UApp>
</template>
